export default __webpack_public_path__ + "static/media/hht2_home_img_EP18.550dfe22.png";